import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ConfirmResetPasswordComponent } from './confirm-reset-password/confirm-reset-password.component';
import { LoginComponent } from './login/login.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { ImpersonateComponent } from './impersonate/impersonate.component';
import { AlreadyAuthenticatedGuard } from '@app/@shared/guards/already-authenticated.guard';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'auth/login',
  },
  {
    path: 'auth/login',
    component: LoginComponent,
    canActivate: [AlreadyAuthenticatedGuard],
    data: { title: 'Enroll And Pay' },
  },
  {
    path: 'auth/reset-password',
    component: ResetPasswordComponent,
    data: { title: 'Enroll And Pay' },
  },
  {
    path: 'auth/confirm-reset-password/:passwordResetId',
    component: ConfirmResetPasswordComponent,
    data: { title: 'Enroll And Pay' },
  },
  {
    path: 'auth/impersonate/:jwt',
    component: ImpersonateComponent,
    data: { title: 'Enroll And Pay' },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
})
export class AuthRoutingModule {}
